<template>
  <div class="flex items-center">
    <div class="relative inline-block w-10 mr-2 align-middle
    select-none transition duration-200 ease-in">
      <input
        type="checkbox"
        name="toggle"
        id="toggle"
        class="toggle-checkbox absolute block w-6 h-6 rounded-full
          bg-white border-4 appearance-none cursor-pointer"
        :checked="checked"
        @change="$emit('changed')"
      />
      <label
          for="toggle"
          class="toggle-label block overflow-hidden h-6 rounded-full
           bg-gray-300 cursor-pointer">
      </label>
    </div>
    <label for="toggle" class="text-gray-600">
        <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change',
  },

  props: ['checked'],

};
</script>

<style scoped>

.toggle-checkbox:checked {
    right: 0;
    border-color: #68D391;
}
.toggle-checkbox:checked + .toggle-label {
    @apply bg-green-400;
    background-color: #68D391;
}

</style>
